<template>
    <div class="repeat-day-selector">
        <span class="repeat-day-selector__day"
              :class="{'active': selected && selected.includes(key)}"
              @click="selectDay(key)"
              v-for="(day, key) in days">{{ day }}
        </span>
    </div>
</template>

<script>
export default {
  name: "RepeatDaySelector",
  props: ['selected'],
  emits: ['update:selected'],
  data() {
    return {
      days: {1: 'M',
            2: 'T',
            3: 'W',
            4: 'T',
            5: 'F',
            6: 'S',
            7: 'S'},
      selected_days: this.selected.slice()
    }
  },
  watch: {
    selected_days() {
      // Emit the updated value of selected_days when it changes
      this.$emit("update:selected", this.selected_days);
    }
  },
  methods: {
    selectDay(key) {
      if (this.selected.includes(key)) {
        const index = this.selected.indexOf(key);
        this.selected.splice(index, 1);
      } else {
        this.selected.push(key);
      }
    }
  }
}

</script>

<style scoped>

</style>
